import { useQuery } from "@tanstack/react-query";
import { getGraphQLClient } from "../lib/graphql";

interface CountriesGroupByResponse {
  factInvoices: {
    groupBy: { fields: { Country: string | null } }[];
  };
}

const COUNTRIES_QUERY = `
  query {
    factInvoices {
      groupBy(fields: [Country]) {
        fields {
          Country
        }
      }
    }
  }
`;

export function useCountries(isAuthenticated: boolean) {
  const {
    data: countries = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["countries"],
    queryFn: async ({ signal }) => {
      const response =
        await getGraphQLClient().request<CountriesGroupByResponse>(
          COUNTRIES_QUERY,
          signal,
        );
      const groups = response.factInvoices?.groupBy || [];
      return groups
        .map((g) => g.fields.Country)
        .filter((c): c is string => typeof c === "string" && c !== "")
        .sort((a, b) => a.localeCompare(b));
    },
    enabled: isAuthenticated,
    staleTime: Infinity,
    retry: 2,
  });

  return { countries, isLoading, error };
}
